import script from "./AlertPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./AlertPopup.vue?vue&type=script&setup=true&lang=js"

import "./AlertPopup.vue?vue&type=style&index=0&id=06ef9f29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06ef9f29"]])

export default __exports__